import { render, staticRenderFns } from "./CadastroTipoBloqueioLeito.vue?vue&type=template&id=1f63065c&"
import script from "./CadastroTipoBloqueioLeito.vue?vue&type=script&lang=js&"
export * from "./CadastroTipoBloqueioLeito.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports